{
    "locale": "sv-SE",
    "cart": {
        "engraving-line-1": "Gravyr rad 1",
        "engraving-line-2": "Gravyr rad 2",
        "key-number": "Nyckelnummer",
        "item-number-short": "Art.nr",
        "whatever": "vad som helst",
        "subtotal": "Delsumma",
        "shipping": "Frakt",
        "shipping-costs": "Frakt",
        "less-30eur-order-value": "under 300 kr beställningsvärde",
        "without-vat-short": "exkl. moms",
        "with-percent-vat-short": "inkl. {percent}% moms",
        "total": "Totalt",
        "dealer-conditions-info": "Observera att dina villkor endast visas på fakturan.",
        "checkout now": "Till kassan",
        "cart-is-empty": "Varukorgen är tom",
        "shopping-now": "Handla nu »",
        "remove": "ta bort",
        "close-cart": "Töm varukorgen"
    },
    "overlay": {
        "close": "stäng"
    },
    "properties": {
        "free-shipping": "Fri frakt vid köp över 30 Euro (i DE)",
        "quick-delivery": "Snabba leveranstider",
        "secure-payment": "Säker betalning",
        "uncomplicated-purchase": "Okomplicerat köp",
        "purchase-on-account": "Köp på faktura"
    },
    "dealer-login": {
        "headline": "ÅF login",
        "logged-in-info-html": "Du är inloggad med ÅF-nummer <b>{number}</b>.",
        "logout": "Logga ut",
        "dealer-number": "ÅF-nummer",
        "error": "Ett fel har uppstått! Vänligen försök igen senare.",
        "invalid-login": "ogiltigt login",
        "login": "Logga in",
        "prompt": "Ange ditt ÅF-nummer och postnummer för att gå till ÅF-butiken.",
        "problem-contact-html": "Kontakta oss vid problem:<br /><a href=\"mailto:info@renzshop.se\">info@renzshop.se</a>",
        "password": "password"
    },
    "footer": {
        "overview": "Översikt",
        "shop-service": "Butiksservice",
        "contact": "Kontaktinformation",
        "social-media": "Sociala medier",
        "sustainability": "Hållbarhet",
        "sustainability-text": "RENZ använder sig helt av grön el.",
        "we-ship-with": "Vi skickar med"
    },
    "header": {
        "menu": "Meny",
        "service-area": "Serviceområde",
        "my-orders": "Mina beställningar",
        "login": "Login",
        "logout": "Logout",
        "back": "tillbaka",
        "purchase-on-account": "Köp mot faktura",
        "short-delivery-time": "Korta leveranstider",
        "secure-payment": "Säker betalning"
    },
    "mobile-search": {
        "headline": "Bläddra i butik",
        "placeholder": "Artikelbenämning eller artikelnummer"
    },
    "site-nav": {
        "all-products": "Alla produkter"
    },
    "econfig-teaser": {
        "to-configurator": "till konfigurator",
        "to-products": "till produkterna"
    },
    "options": {
        "headline": "Alternativ",
        "confirm-selection": "Bekräfta valet"
    },
    "inquiry": {
        "error-alert": "Det har blivit ett fel. Begäran behandlades inte. Vänligen försök igen senare.",
        "headline": "Gör en förfrågan",
        "success": "Tack för din förfrågan!",
        "success-headline-offer-assistant": "Din begäran har vidarebefordrats",
        "success-offer-assistant": "Din förfrågan har vidarebefordrats till den återförsäljare du valde för behandling.",
        "firstname": "Förnamn",
        "optional": "optional",
        "lastname": "Efternamn",
        "company": "Företag",
        "street": "Gata",
        "house-number": "Gatunummer",
        "country": "Land",
        "default-country": "Sweden",
        "postcode": "Postnummer",
        "city": "Postort",
        "email": "E-post",
        "phone": "Telefonnummer",
        "phone-tooltip": "Telefonnumret kommer att vidarebefordras till speditören.",
        "commission": "Provision",
        "construction-project": "Byggprojekt",
        "special-request": "Specialförfrågningar",
        "special-request-placeholder": "Om du anger en specialförfrågan så kan detta köp inte längre genereras automatiskt. En återförsäljare kommer att kontakta dig inom de närmaste dagarna.",
        "dealer-choice-intro": "Välj en återförsäljare nedan. Efter sändning får du ett icke-bindande erbjudande inom de närmaste minuterna.",
        "dealer-choice-prompt": "Välj en återförsäljare",
        "local-dealer": "Regional fackhandlare",
        "please-choose": "Vänligen välj",
        "within-radius-of": "inom radien av",
        "no-dealer-within-radius": "Inga återförsäljare hittades i området!",
        "no-dealer-for-postcode": "Sökningen gav inga resultat för det angivna postnumret!",
        "or": "eller",
        "renz-online-partner": "RENZ Online Partner",
        "privacy-terms-checkbox-html": "Genom att skicka in detta formulär godkänner du <a href=\"/service/datenschutz\" >RENZ sekretessvillkor</a >.<br /> Dina uppgifter kommer att vidarebefordras till återförsäljaren du valde ovan, som sedan kommer att ge dig ett individuellt erbjudande.",
        "send": "Skicka",
        "dealer-preselected-intro": "Förfrågan går till följande fackhandlare:",
        "customer-type": {
            "end": "Slutkund",
            "business": "Företagskund",
            "desired-retail-partner-label": "Önskad handelspartner",
            "desired-retail-partner-placeholder": "Ange önskad handelspartner med plats och kontaktperson."
        }
    },
    "product": {
        "load-more": "ladda fler",
        "item-number-short": "Art.nr",
        "preview-not-matching-color": "Den aktuella förhandsgranskningsbilden matchar inte den valda färgen!",
        "options": "Alternativ",
        "no-option-selected": "inget alternativ valt",
        "retail-price-excl-vat": "Rekommenderat pris exkl. moms",
        "retail-price-incl-vat": "Rekommenderat pris inkl. moms",
        "choose-color": "Färgval",
        "choose-color-intro-html": "Hos Renz har du över 200 färger att välja mellan, bland vilka du säkert hittar din önskade färg. De flesta färger kommer från RAL-skalan.",
        "search-color": "Sök",
        "colors-with-preview": "Färger med förhandsvisning",
        "colors-without-preview": "Färger utan förhandsvisning",
        "back-to-overview": "tillbaka till översikt",
        "delivery-time": "Leveranstid",
        "retail-price": "Rekommenderat pris",
        "excl-vat": "exkl. moms",
        "incl-vat": "inkl. moms",
        "plus-shipping": "plus frakt",
        "dealer-conditions-info": "Observera att dina villkor endast visas på fakturan.",
        "dealer-fixed-price-info": "",
        "any-key-number": "valfritt nyckelnummer",
        "key-number": "Nyckelnummer",
        "key-number-in-range-from": "Vänligen ange det nyckelnummer du behöver utan bokstäver: i intervallet från",
        "key-number-in-range-to": "till",
        "engraving-line-1": "Gravyr rad 1",
        "count-characters-left-html": "Fortfarande <span class=\"num\">{count}</span> tillgängliga tecken",
        "engraving-line-2": "Gravyr rad 2",
        "make-inquiry": "Gör en förfrågan",
        "add-to-cart": "i varukogen",
        "description": "Beskrivning",
        "downloads": "Downloads",
        "quantity": "Antal",
        "weeks": "Veckor",
        "working-days": "arbetsdagar"
    },
    "product-filter": {
        "material": "Material",
        "all-materials": "alla material",
        "plastic": "Plast",
        "aluminium": "Aluminium",
        "stainless-steel": "Rostfritt",
        "price": "Pris",
        "punch-width": "Bredd stansning",
        "punch-height": "Höjd stansning",
        "outer-width": "Yttre bredd",
        "outer-height": "Yttre höjd",
        "reset-all": "Återställ allt",
        "construction-year": "Byggår"
    },
    "checkout": {
        "back": "tillbaka",
        "next": "nästa",
        "info-and-shipping": "Information & Leverans",
        "payment": "Betalning",
        "summary": "Summering",
        "order": "Beställning",
        "thank-you-for-order": "Stort tack för din beställning",
        "order-comfirmation-html": "Tack för att du valde Renz Shop. Du kommer inom kort att få en orderbekräftelse från oss till din angivna e-postadress.",
        "error-alert": "Ett fel har uppstått. Beställningen behandlades inte. Vänligen försök igen senare.",
        "cart": "Varukorg",
        "delivery-and-billing-address": "Leverans- och faktureingsadress",
        "dealer-number": "ÅF-nummer",
        "dealer-address-info-html": "Adressuppgifterna som lagras hos oss kommer att användas. Om dessa uppgifter ändras, vänligen kontakta oss.",
        "further-data": "ytterligare uppgifter",
        "dealer-email-prompt": "Du kan ange en e-postadress här om du vill ha en orderbekräftelse via e-post.",
        "email": "E-post",
        "dealer-commission-prompt": "Följande provisionsfält lagras i din orderbekräftelse.",
        "commission": "Provision",
        "invoice": "Faktura",
        "store-my-data": "Spara mina beställningsuppgifter på den här datorn",
        "order-now": "Beställ nu",
        "contact-data": "Kontaktuppgifter",
        "phone": "Telefonnummer",
        "shipping-address": "Leveransadress",
        "firstname": "Förnamn",
        "lastname": "Efternamn",
        "street": "Gata",
        "house-number": "Husnummer",
        "postcode": "Postnummer",
        "city": "Postort",
        "country": "Land",
        "billing-address": "Faktueringsadress",
        "back-to-payment": "tillbaka till betalning",
        "paypal-error-alert": "Paypal-fel: Vänligen försök igen senare!",
        "pay-via-invoice": "Betala via faktura",
        "paypal-language-code": "sv_SE",
        "payment-type": "Betalningstyp",
        "invoice-possible-notice-html": "Köp på faktura är endast möjligt upp till ett fakturabelopp på 500 kr.",
        "back-to-shipping": "tillbaka till frakt",
        "contact-info": "Kontaktinformation",
        "optional": "valfritt",
        "delivery-country-notice-html": "Observera att vi är för närvarande <b>endast leverar till Sverige</b>.",
        "back-to-shop": "tillbaka till butik",
        "proceed-to-payment": "vidare till betalning",
        "checkout": "Kassa",
        "right-of-withdrawal-checkbox-html": "Jag accepterar <a href=\"/service/widerruf\" onclick=\"return openOverlay(this.href)\" >ångerrättsvillkoren</a >",
        "privacy-terms-checkbox-html": "Jag accepterar <a href=\"/service/datenschutz\" onclick=\"return openOverlay(this.href)\">sekretessvillkoren</a >",
        "general-terms-checkbox-html": "Jag accepterar <a href=\"/service/agb\" onclick=\"return openOverlay(this.href)\" >de allmänna villkoren</a >",
        "klarna": "Klarna",
        "paypal": "Paypal",
        "address-supplement": "adresstillägg",
        "company": "företag",
        "same-as-shipping-address": "Samma som leveransadress",
        "different-billing-address": "En annan faktureringsadress"
    },
    "meta": {
        "description": "Renz Shop för reservdelar, gravyrservice och fastighetsboxar"
    },
    "contact-form": {
        "success": "Vi har tagit emot ditt meddelande. Vi kommer att behandla din förfrågan så snabbt som möjligt.",
        "error": "Ett fel har uppstått! Vänligen försök igen senare.",
        "firstname": "Förnamn",
        "optional": "optional",
        "lastname": "Efternamn",
        "email": "E-post",
        "street": "Gata",
        "house-number": "Husnummer",
        "postcode": "Postnummer",
        "city": "Postort",
        "subject": "Betreff",
        "message": "Meddelande",
        "file-upload": "Filuppladdning",
        "send": "Skicka",
        "privacy-terms-checkbox-html": "Jag accepterar <a href=\"/service/datenschutz\" onclick=\"return openOverlay(this.href)\">sekretessvillkoren</a >"
    },
    "category": {
        "products": "Produkter",
        "sorting": "Sortering",
        "by-name": "Namn",
        "by-price-asc": "Pris ↥",
        "by-price-desc": "Pris ↧"
    },
    "service": {
        "service-area": "Serviceområde",
        "service": "Service"
    },
    "search": {
        "search-for": "Sök efter {search}",
        "search-for-html": "Produktsök <small>efter {search}</small>",
        "count-hits": "{count} träffar",
        "sorting": "Soreting",
        "by-name": "sorterat efter namn",
        "by-price-asc": "Pris stigande",
        "by-price-desc": "Pris fallande"
    },
    "home": {
        "search-placeholder": "Artikelbenämning eller artikelnummer",
        "search": "Suchen"
    },
    "my-orders": {
        "order-details": "Beställningsdetaljer",
        "order-intro-html": "Tack för din beställning, nedan finner du detaljerna.",
        "back-to-orders": "tillbaka till min beställning",
        "order-from-date": "Beställning från {date}",
        "order-number-short": "Beställningsnr",
        "payment-info": "Betalningsinformation",
        "invoice": "Faktura",
        "contact": "Kontakt",
        "email": "E-post",
        "phone": "Telefonnummer",
        "firstname": "Förnamn",
        "lastname": "Efternamn",
        "street-and-house-number": "Gata och husnummer",
        "postcode": "Postnummer",
        "city": "Postort",
        "country": "Land",
        "ordered-items": "beställda artiklar",
        "item-number-short": "Artnr",
        "engraving-line-1": "Gravyr rad 1",
        "engraving-line-2": "Gravyr rad 2",
        "key-number": "Nyckelnummer",
        "whatever": "vad som helst",
        "pieces": "st",
        "shipping-costs": "fraktkostnader",
        "total-costs": "totalpris",
        "vat-included": "inkl. moms",
        "order-not-found": "Beställningen hittades inte",
        "my-orders": "Min beställning",
        "intro-html": "Här hittar du en översikt över alla dina beställningar.",
        "click-link-prompt": "Klicka här för att begära en ny länk.",
        "access-denied": "Tillträde beviljas ej!",
        "link-is-invalid": "Länken är inte längre giltig.",
        "view-order": "Se beställning",
        "no-order-for-email-html": "Inga beställningar har ännu sparats i vårt system för din e-postadress.",
        "load-more": "ladda fler",
        "error": "Ett fel har uppstått! Vänligen försök igen senare.",
        "link-request-intro-html": "Om du redan har lagt en beställning kan du se din beställningshistorik här med den e-postadress som används.",
        "link-request-success": "Länken har skickats till dig via e-post. Kontrollera din inkorg och om det behövs din spamkorg.",
        "send-link": "Skicka beställningslänk"
    },
    "not-found": {
        "site-not-found": "Sidan hittades inte"
    },
    "product-config": {
        "configurator": "Konfigurator",
        "reset-all": "Återställ alla filter",
        "back": "tillbaka",
        "next": "nästa",
        "select-not-included": "Ditt val saknas?",
        "item-number-short": "Art.nr",
        "more-details": "fler detaljer",
        "retail-price": "Rekommenderat pris",
        "excl-vat": "exkl. moms",
        "incl-vat": "inkl. moms",
        "make-inquiry": "Gör en förfrågan"
    },
    "klarna": {
        "error": "Det har blivit ett fel. Var god försök igen.",
        "proceed": "fortsätt med Klarna",
        "order_now": "Beställ nu och betala med Klarna"
    },
    "paypal": {
        "order_now": "Betala nu och beställ med"
    },
    "offer-assistant": {
        "title": "Konfiguratorn",
        "ok": "OK",
        "close": "Avsluta konfiguratorn",
        "welcome-title": "Välkommen till konfiguratorn",
        "welcome-text": "Här erbjuder vi dig möjligheten att konfigurera ditt brevlådesystem i detalj.<br/>För att göra detta, gå igenom stegen efter varandra och välj önskade egenskaper.<br/>Efter färdigställandet kommer du inom kort att få ett detaljerat erbjudande inklusive anbudstext, teknisk ritning och fotorealistisk vy."
    }
}
